// extracted by mini-css-extract-plugin
export default {"navItem":"whats-on-filters_navItem__3fKX6 typography_bodyFont__1UNdB","active":"whats-on-filters_active__3k62J"};